import { render, staticRenderFns } from "./PerformanceStats.vue?vue&type=template&id=fe36822c&scoped=true"
import script from "./PerformanceStats.vue?vue&type=script&lang=js"
export * from "./PerformanceStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36822c",
  null
  
)

export default component.exports